export default "__VITE_ASSET__f97b1846__"